module.exports = __webpack_public_path__ + "static/8-5ad4ce4247fb19cea8e3d2263ed7a675.png";